































import { Component, Prop, Vue } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper";
import { CloudAccount } from "@/cloudAccount/cloudAccount";

import { UserConfigColors } from "@/userConfigColors/userConfigColors";

@Component({
  components: {
  }
})
export default class SelectSns extends Vue {
    
    title = "連携するSNSを選択してください";

    private get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private selectSns(selectSnsType: number){
        this.$emit('doCommand', "selectSns", selectSnsType);
        this.$emit('close');
    }

    private returnTemplate(){
        this.$router.push("/SelectTemplate");
    }

    private getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
